/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'less': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M25 1c13.233 0 24 10.767 24 24S38.233 49 25 49 1 38.233 1 25 11.767 1 25 1zm0 2.667C13.237 3.667 3.667 13.237 3.667 25c0 11.763 9.57 21.333 21.333 21.333 11.763 0 21.333-9.57 21.333-21.333 0-11.763-9.57-21.333-21.333-21.333zM34 23.5a1.5 1.5 0 010 3H16a1.5 1.5 0 010-3h18z" _fill="#0D658E" fill-rule="evenodd"/>'
  }
})
